import React from 'react';
import './EmptyTodos.css'


function EmptyTodos() {
  
  return (
    <div className='Empty-Todo'>
      <p>Encuentra tu ejercicio</p>
    </div>
  );
}

export { EmptyTodos };